import { configureStore } from '@reduxjs/toolkit';
import loginUserReducer from './loginUserSlice.js';
import foodReducer from './foodSlice';
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage,
}

const perisitedReducer = persistReducer(persistConfig, loginUserReducer)

export const store = configureStore({
  reducer: {
    food: foodReducer,
    loginUser: perisitedReducer
  }, middleware: ((getDefaultMiddleWare) => getDefaultMiddleWare({
    serializableCheck: false
  }))
})

export const persister = persistStore(store)